module.exports = __webpack_public_path__ + "img/footer-1_jp.72dcaf8.jpg";